import React from 'react';
import {OverlayTrigger, Tooltip} from "react-bootstrap";

const isTopLandlord = (landlord) => landlord?.topLandlord === true || landlord?.topLandlord === "true";

const LANDLORD_LEVELS = ["none", "risingStar", "topLandlord"];
const LANDLORD_LEVEL_LABELS = {none: "No Level", risingStar: "Rising Star", topLandlord: "Top Landlord"};

// O nivel passou a ser atribuido pelo job diario do backend e vive no landlordLevel. Os senhorios
// que ainda nao passaram pelo job nao o tem, por isso cai-se para o selo antigo em vez de mostrar
// "sem nivel" a quem ainda o tem.
const getLandlordLevel = (landlord) => {
    if (LANDLORD_LEVELS.includes(landlord?.landlordLevel)) return landlord.landlordLevel;
    return isTopLandlord(landlord) ? "topLandlord" : "none";
};

const getLandlordLevelLabel = (landlord) => LANDLORD_LEVEL_LABELS[getLandlordLevel(landlord)];

const TopLandlordIcon = ({landlord, className}) => {
    if (!isTopLandlord(landlord)) return null;
    return (
        <OverlayTrigger overlay={<Tooltip>Top Landlord</Tooltip>}>
            <i data-tag="allowRowEvents" aria-label={"Top Landlord"}
               className={"mdi mdi-crown text-warning" + (className ? " " + className : "")}/>
        </OverlayTrigger>
    )
};

export {isTopLandlord, getLandlordLevel, getLandlordLevelLabel, LANDLORD_LEVELS, LANDLORD_LEVEL_LABELS};
export default TopLandlordIcon;
